export function toNullOrString(input: string | undefined | null): string | null {
    if (input === "" || input === undefined) {
        return null;
    }

    return input;
}
